import React from "react";
import {
  Brain,
  Building2,
  CalendarCheck,
  ClipboardCheck,
  FileText,
  GraduationCap,
  Layers,
  MessagesSquare,
  Video,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import FeatureCard from "../components/FeatureCard";
import Section from "../components/Section";
import SectionHeading from "../components/SectionHeading";
import { SECTION_IDS } from "../landingConfig";

const MODULES = [
  { key: "diagnostics", Icon: Brain },
  { key: "zones", Icon: Layers },
  { key: "consultations", Icon: MessagesSquare },
  { key: "observations", Icon: ClipboardCheck },
  { key: "trainings", Icon: GraduationCap },
  { key: "meetings", Icon: CalendarCheck },
  { key: "forms", Icon: FileText },
  { key: "video", Icon: Video },
  { key: "org", Icon: Building2 },
];

export default function Modules() {
  const { t } = useTranslation();

  return (
    <Section id={SECTION_IDS.features}>
      <SectionHeading
        eyebrow={t("landing.modules.eyebrow")}
        title={t("landing.modules.h2")}
      />
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {MODULES.map(({ key, Icon }, i) => (
          <FeatureCard
            key={key}
            Icon={Icon}
            index={i % 3}
            title={t(`landing.modules.${key}_title`)}
            body={t(`landing.modules.${key}_body`)}
          />
        ))}
      </div>
    </Section>
  );
}
